export default {
  404: {
    title: 'Page non trouvée',
    text: "La page que vous recherchez n'est pas disponible.<br /> Essayez de revenir à la page d’accueil ou réessayez plus tard.",
  },
  500: {
    title: 'Erreur interne du serveur',
    text: "Désolé, une erreur interne s'est produite. <br />Nous travaillons à la résoudre dans les plus brefs délais.",
  },
}
